<template>
  <div class="login-warp">
    <top-nav-menu>
      <div class="nav-list" style="height: 90px; line-height: 90px">
        <template v-for="item in menuList">
          <router-link
            v-if="item.target === 'self'"
            :class="['menu-item']"
            :key="item.name"
            :to="item.path"
            >{{ item.name }}</router-link
          >
          <a
            class="menu-item"
            v-else-if="item.target === 'blank'"
            :href="item.path"
            target="_blank"
            :key="item.name"
            >{{ item.name }}</a
          >
        </template>
      </div>
    </top-nav-menu>
    <slot></slot>
    <div class="foot-bar">
      <div class="foot-bar-warp">
        <div class="foot-section1">
          <div class="foot-section-text">
            <img
              style="width: 12px; height: 12px"
              src="../../../assets/image/6.png"
              alt=""
            />
            甘肃云创空间网络科技有限公司
            <a
              href="http://beian.miit.gov.cn"
              target="_blank"
              style="color: #e9ecf0"
              >陇ICP备2021000911号</a
            >
          </div>
          <div class="foot-section-text">
            甘肃省兰州市城关区张掖路街道通渭路137号2单元803室
          </div>
        </div>
        <div class="foot-section2">
          <div class="foot-section-text">
            <img
              style="width: 12px; height: 12px; margin-right: 5px"
              src="../../../assets/image/7.png"
              alt=""
            />投诉电话：400-606-1027
          </div>
          <div class="foot-section-text">
            互联网域名服务许可证：
            <a
              href="https://domain.miit.gov.cn/域名注册服务机构/互联网域名/甘肃云创空间网络科技有限公司"
              rel="nofollow"
              target="_blank"
              style="color: #e9ecf0"
              >甘D3-20220001</a
            >
          </div>
          <div class="foot-section-text"></div>
        </div>
        <div class="foot-section3">
          <!-- &nbsp; -->
          <div class="foot-section-text">
            <img
              style="width: 12px; height: 12px; margin-right: 5px"
              src="../../../assets/image/8.png"
              alt=""
            />客服邮箱：kfdomain@yc0597.com
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topNavMenu from "components/topNavMenu";

export default {
  name: "layout",
  components: {
    topNavMenu,
  },
  data() {
    return {
      menuList: [
        {
          name: "域名注册",
          path: "/index",
          target: "self",
        },
        {
          name: "关于我们",
          path: "http://yc0597.com/gywm",
          target: "blank",
        },
        {
          name: "新闻资讯",
          path: "http://yc0597.com/xwzx",
          target: "blank",
        },
        {
          name: "联系我们",
          path: "http://yc0597.com/lxwm",
          target: "blank",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.login-warp {
  position: relative;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  // min-height: 100vh;
  .menu-item {
    color: #fff;
    line-height: 60px;
    font-weight: 400;
    font-size: 16px;
    margin-right: 40px;
  }
}
.foot-nav {
  display: flex;
  align-items: center;
  background-color: #315491;
  height: 100px;
  padding-top: 40px;
  .foot-nav-warp {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .link {
      width: 120px;
      height: 45px;
      line-height: 45px;
      border-radius: 5px;
      border: 1px solid #759de6;
      text-align: center;
      font-size: 14px;
      color: #fff;
      font-weight: 400;
    }
    .link.active {
      color: #fff;
      background-color: #3992e9;
      border-color: #3992e9;
    }
  }
}
.foot-bar {
  background-color: #315491;
  // border-top: 1px solid #ffffff1a;
  .foot-bar-warp {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    padding-top: 20px;
    padding-bottom: 40px;
    .foot-section-text {
      font-weight: 400;
      font-size: 14px;
      color: #e9ecf0;
      &:nth-child(n + 2) {
        margin-top: 25px;
      }
    }
    .foot-section2 {
      margin-left: 80px;
    }
    .foot-section3 {
      flex: 1;
      display: flex;
      justify-content: space-between;
      margin-left: 100px;
      .customer {
        margin-top: 21px;
        width: 110px;
        text-align: center;
        height: 46px;
        line-height: 46px;
        color: #e9ecf0;
        cursor: pointer;
      }
    }
  }
}
.nav-list {
  position: relative;
  &::before {
    content: "";
    display: inline-block;
    position: absolute;
    width: 75px;
    height: 2px;
    background-color: #fff;
    bottom: 0;
    left: -5px;
  }
}
</style>
